import {
	VENDORS,
	DEPARTMENTS,
	CATEGORIES,
} from "components/Shared/GlobalFilter/constants"

import { RequestParameters } from "components/Shared/Filters/interfaces"

const mandatoryFilters: Array<keyof RequestParameters> = [
	VENDORS,
	DEPARTMENTS,
	CATEGORIES,
]

export default mandatoryFilters
